import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { MeetingsExplorer } from '../components/widgets/ExecMeetings/MeetingsExplorer';
import '../components/widgets/ExecMeetings/styles.css';

// Control-tower LAYER 3 — the per-meeting explorer, on its own page so it does NOT
// load together with the meetings drill (layer 2). Reached via a link from the drill.
export default function ExecMeetingsListPage() {
  const navigate = useNavigate();
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="סייר פגישות · רשימה מלאה" />
        <main className="flex-1 overflow-y-auto p-6">
          {/* One unified dark surface (same palette + surface as the meetings drill) so
              the explorer inherits our --ex-* theme instead of rendering on gray. */}
          <div className="mtg-wrap">
            <button
              onClick={() => navigate('/exec/meetings')}
              style={{ background: 'none', border: '1px solid var(--ex-border)', color: 'var(--ex-text-secondary)', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', marginBottom: 12 }}
            >
              ← דשבורד פגישות
            </button>
            <MeetingsExplorer backMonths={[]} />
          </div>
        </main>
      </div>
    </div>
  );
}
